"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_JOBROLES_HASH = void 0;
exports.GET_JOBROLES_HASH = `
  {
    jobRoles
  }
`;
//# sourceMappingURL=jobRoles-queries.js.map